import React from "react";
import Spinner from '~components/spinner';
import './style.scss';

function MainLoader() {
    return (
        <div className="main-loader">
            <Spinner size={57} borderWidth={4} />
        </div>
    );
}

export default MainLoader;
export { MainLoader };



// WEBPACK FOOTER //
// ./src/components/main-loader/index.js